module.exports = __webpack_public_path__ + "fc5ab42eaa959f91364dea2e53b9f2f3.svg";